import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Button, SelectField, NumberField, TextField } from 'ui-toolkit';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { manualCheckDisbursementCategoryOptions } from '../../../../../types/accounting/eManualCheckDisbursementCategory';
import { IManualCheckDisbursementData } from '../../../../../types/order/escrow/IManualCheckDisbursementData';
import GrayLine from '../../../../shared/GrayLine';
import { CreateEditManualCheckDisbursementNumberDate } from './CreateEditManualCheckDisbursementNumberDate';
import { CreateEditManualCheckDisbursementAlertAndPDFButton } from './CreateEditManualCheckDisbursementAlertAndPDFButton';
import { stateFilterOptions } from '../../../../../utilities/shared/stateFilterOptions';
import { useHasPermissions } from '../../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { StatesLabelValue } from '../../../../../ui-toolkit/enums/states';

export interface ICreateEditManualCheckDisbursementRowProps {
  index: number;
  onDelete: (index: number) => void;
  onCreatePDF: (checkId: string) => void;
  fieldName: string;
  checkId?: string;
  check: IManualCheckDisbursementData;
}

export const CreateEditManualCheckDisbursementRow: React.FC<ICreateEditManualCheckDisbursementRowProps> = ({
  index,
  onDelete,
  onCreatePDF,
  fieldName,
  check,
}) => {
  const hasEditPermission = useHasPermissions([ePermissions.EscrowManualCheckDisbursementsEdit]);

  return (
    <>
      <Grid>
        <Grid templateColumns={'5fr 4fr 2fr 1fr'} alignItems={`center`}>
          <TextField
            name={`${fieldName}.${index}.name`}
            label="Beneficiaries"
            placeholder="Samuel L. Jackson"
            readOnly={!hasEditPermission}
          />
          <SelectField
            name={`${fieldName}.${index}.category`}
            options={manualCheckDisbursementCategoryOptions}
            label={'Category'}
            isDisabled={!hasEditPermission}
          />
          <NumberField
            name={`${fieldName}.${index}.amountCents`}
            label="Amount"
            mode="currency"
            placeholder="123,456.78"
            valueIsCents
            disabled={!hasEditPermission}
          />
          <Button intent={'ghost'} isInline onClick={() => onDelete(index)} disabled={!hasEditPermission}>
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </Grid>
        <Grid templateColumns={'4fr 1fr 3fr 2fr 1fr 1fr'} alignItems={'center'}>
          <TextField
            name={`${fieldName}.${index}.mailingAddress.streetAddress`}
            label="Street Address"
            placeholder="155 W 12th Street"
            readOnly={!hasEditPermission}
          />
          <TextField
            name={`${fieldName}.${index}.mailingAddress.unit`}
            label="Unit"
            placeholder="4b"
            readOnly={!hasEditPermission}
          />
          <TextField
            name={`${fieldName}.${index}.mailingAddress.city`}
            label="City"
            placeholder="City"
            readOnly={!hasEditPermission}
          />
          <SelectField
            name={`${fieldName}.${index}.mailingAddress.stateAbbreviation`}
            filterOption={stateFilterOptions}
            options={StatesLabelValue}
            label={`State`}
            placeholder={`Select one...`}
          />
          <TextField
            name={`${fieldName}.${index}.mailingAddress.zipCode`}
            label="Zip"
            placeholder="99999"
            readOnly={!hasEditPermission}
          />
          <div />
        </Grid>
        <Grid templateColumns={'7fr 2fr 2fr 1fr'}>
          <TextField
            name={`${fieldName}.${index}.memo`}
            label="Memo"
            placeholder="Memo"
            readOnly={!hasEditPermission}
          />
          <CreateEditManualCheckDisbursementNumberDate
            check={check}
            fieldName={fieldName}
            index={index}
            hasEditPermission={hasEditPermission}
          />
          <div />
        </Grid>
        <CreateEditManualCheckDisbursementAlertAndPDFButton
          check={check}
          hasEditPermission={hasEditPermission}
          onCreatePDF={onCreatePDF}
        />
      </Grid>
      <GrayLine />
    </>
  );
};
